import React from 'react';
import { motion } from 'framer-motion';
import { TiltCard } from './TiltCard';

export const BentoGrid = ({ children, className = '' }) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-4 md:gap-6 ${className}`}>
      {children}
    </div>
  );
};

export const BentoCard = ({ 
  children, 
  className = '', 
  colSpan = 'md:col-span-3 lg:col-span-4',
  rowSpan = '',
  variant = 'default',
  delay = 0,
  enableTilt = true,
  glowColor = 'rgba(47, 128, 255, 0.1)'
}) => {
  const variants = {
    default: 'bg-[#111C32]/80 border-slate-700/50',
    highlight: 'bg-gradient-to-br from-[#2F80FF]/10 to-[#2DD4BF]/5 border-blue-500/30',
    glass: 'bg-white/5 border-white/10',
    dark: 'bg-[#0a0f1a] border-slate-800'
  };

  const cardContent = (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5, delay }}
      className={`
        relative overflow-hidden rounded-2xl p-6
        border backdrop-blur-xl
        transition-all duration-300
        hover:border-blue-500/40 hover:shadow-lg
        ${variants[variant]}
        ${colSpan}
        ${rowSpan}
        ${className}
      `}
      style={{
        boxShadow: `0 0 40px -10px ${glowColor}`
      }}
    >
      {/* Gradient Glow on Hover */}
      <div 
        className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500 pointer-events-none"
        style={{
          background: `radial-gradient(600px circle at var(--mouse-x, 50%) var(--mouse-y, 50%), ${glowColor}, transparent 40%)`
        }}
      />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </motion.div>
  );

  if (enableTilt) {
    return (
      <TiltCard className={`${colSpan} ${rowSpan}`} tiltAmount={5}>
        {cardContent}
      </TiltCard>
    );
  }

  return cardContent;
};

export default BentoGrid;
